import React from 'react';
import { Notice, Button, ButtonIcon } from '@companycam/slab-web';
import { translate } from 'javascripts/translations/i18n';

const InvoiceFeedbackBanner = ({
  showCloseButton = false,
  onClose,
}: {
  showCloseButton?: boolean;
  onClose?: () => void;
}) => {
  return (
    <Notice
      ccMargin="m 0 xl"
      color="info"
      contentAfter={
        <>
          <Button
            color="secondary"
            design="outline"
            size="small"
            href="https://calendly.com/vanessa-damore/invoice-beta"
            target="_blank"
            ccMargin="s"
          >
            {translate('pages.examples.invoiceBannerScheduleAction')}
          </Button>
          <Button
            color="secondary"
            design="outline"
            size="small"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfpYEsZlGDto3jL2N2KlJZ-QAu7YoUnXp6Dv-G7oabQQBuICA/viewform"
            target="_blank"
          >
            {translate('pages.examples.invoiceBannerAction')}
          </Button>
          {showCloseButton ? (
            <ButtonIcon
              accessibilityLabel="Close invoice survery banner"
              design="minimal"
              iconName="close"
              onClick={onClose}
            />
          ) : null}
        </>
      }
      contentAlign="center"
      iconName="creation"
      size="medium"
    >
      {translate('pages.examples.invoiceBannerMessage')}
    </Notice>
  );
};

export default InvoiceFeedbackBanner;
